import type { PitchItemState } from "./statuses.js";

/**
 * The one vocabulary for pitching and delivery, read by every chip, filter, select, activity line
 * and export. Change a word here and every surface follows.
 */
export const PITCH_ITEM_STATE_LABELS: Record<PitchItemState, string> = {
  draft: "Draft",
  pending: "Waiting on a reply",
  change_requested: "Changes requested",
  rejected: "Rejected",
  accepted: "Accepted",
  withdrawn: "Withdrawn",
};

/**
 * Shorter words for a chip where the recipient follows on the same chip ("Waiting · Label X").
 * Anywhere else, use `PITCH_ITEM_STATE_LABELS`.
 */
export const PITCH_ITEM_STATE_SHORT_LABELS: Record<PitchItemState, string> = {
  ...PITCH_ITEM_STATE_LABELS,
  pending: "Waiting",
};

/** Whether a song has what a label needs once a pitch is accepted: a final demo and stems. */
export const DELIVERY_STATES = ["complete", "demo_only", "stems_only", "incomplete"] as const;
export type DeliveryState = (typeof DELIVERY_STATES)[number];

export const DELIVERY_STATE_LABELS: Record<DeliveryState, string> = {
  complete: "Complete",
  demo_only: "Demo only",
  stems_only: "Stems only",
  incomplete: "Incomplete",
};

/** The verb for opening the side inspector (peek) on a song, brief, pitch or person. */
export const QUICK_LOOK_LABEL = "Quick look";
